import SliceFactory from 'components/v2/contentful/sliceFactory/SliceFactory';
import { BaseStyles } from 'theme-ui';
import { TypePageFields } from 'types/contentful-types';
import { CONTAINER_MAX_WIDTH } from 'styles/theme';
import useBreakpoint from 'utils/hooks/useBreakpoint';
import AnchorNav from 'components/v2/slices/anchorNav/AnchorNav';
import { useEffect, useState } from 'react';
import CalloutNotification from 'components/v2/atomic/calloutNotification/CalloutNotification';
import { isEmpty } from 'lodash';

const generateStickyNavData = (
  hasStickyNav?: boolean,
  data?: TypePageFields
) => {
  if (!hasStickyNav || hasStickyNav === undefined) return null;
  return data?.content
    ?.filter(
      slice =>
        slice.sys.contentType.sys.id === 'banner' &&
        slice.fields.bannerTitle !== data.title
    )
    .map(slice => ({
      label: slice.fields.bannerTitle,
      id: slice.fields.bannerTitle
        ?.toLowerCase()
        .replace(/[^\w\s]/gi, '')
        .split(' ')
        .join('-')
    }));
};

const StaticContentPage = ({ data }: { data: TypePageFields }) => {
  const breakpoint = useBreakpoint();
  const [showWarning, setShowWarning] = useState(false);

  const stickyNavHeaderData = generateStickyNavData(
    data?.hasStickyNavigation,
    data
  );

  const filteredStickyNavHeaderData = stickyNavHeaderData?.filter(
    navData => navData.label && navData.id
  );

  useEffect(() => {
    if (
      process.env.NEXT_PUBLIC_APP_ENV !== 'prod' &&
      data?.hasStickyNavigation
    ) {
      if (
        !stickyNavHeaderData ||
        isEmpty(stickyNavHeaderData) ||
        stickyNavHeaderData.some(headerData => !headerData.label)
      ) {
        setShowWarning(true);
        return;
      }
      setShowWarning(false);
    }
  }, [data?.hasStickyNavigation, stickyNavHeaderData]);

  return (
    <div>
      <BaseStyles>
        {showWarning && (
          <CalloutNotification
            id="missing-banner"
            intent="warning"
            onDismiss={() => setShowWarning(false)}
          >
            Oops! It looks like banners and/or their titles are missing for the
            Sticky Navigation Bar.
          </CalloutNotification>
        )}
        {filteredStickyNavHeaderData && data.hasStickyNavigation ? (
          <AnchorNav offset={50} navData={filteredStickyNavHeaderData} />
        ) : null}
        {data?.content?.map(slice => (
          <div
            key={slice.sys.id}
            sx={{
              maxWidth:
                slice.sys.contentType.sys.id === 'banner' ||
                slice.sys.contentType.sys.id === 'sectionContainer' ||
                slice.sys.contentType.sys.id === 'heroBanner'
                  ? '100%'
                  : CONTAINER_MAX_WIDTH,
              margin: '0 auto',
              padding:
                slice.sys.contentType.sys.id === 'banner' ||
                slice.sys.contentType.sys.id === 'sectionContainer' ||
                slice.sys.contentType.sys.id === 'heroBanner'
                  ? '0'
                  : breakpoint.isLessThanLargeMin
                  ? '0 2rem'
                  : '0'
            }}
          >
            <SliceFactory key={slice.sys.id} slice={slice} />
          </div>
        ))}
      </BaseStyles>
    </div>
  );
};

export default StaticContentPage;
